import { render, staticRenderFns } from "./addTestItem.vue?vue&type=template&id=5ebc9d68&scoped=true"
import script from "./addTestItem.vue?vue&type=script&lang=js"
export * from "./addTestItem.vue?vue&type=script&lang=js"
import style0 from "./addTestItem.vue?vue&type=style&index=0&id=5ebc9d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebc9d68",
  null
  
)

export default component.exports